export default "__VITE_ASSET__3fef84c3__"